import { PersonalPlanning } from "app/models/timeslot"
import { Action, Types } from "./personalPlanning.actions"

export type PersonalPlanningParams = {
  from: string
  to: string
}

export type PersonalPlanningState = {
  errors: {}
  loading: boolean
  data: PersonalPlanning
}

const initialState: PersonalPlanningState = {
  errors: {},
  loading: false,
  data: {
    hrUnavailabilities: [],
    hrGeneralLeaves: [],
    planningTimeslots: [],
  },
}

export default (state = initialState, action: Action): PersonalPlanningState => {
  switch (action.type) {
    case Types.GET:
      return {
        ...state,
        loading: true,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }
    default:
      return state
  }
}
